import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link, useLocation } from "react-router-dom";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Loader from "../../Components/Loader";
import { useEffect, useState, useContext } from "react";
import { TokenContext } from "../../Components/TokenContext";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ListServices(props) {
  const apiToken = useContext(TokenContext);
  const [servicesList, setServicesList] = useState();
  const [serviceId, setServiceId] = useState();
  const [isOpen, toggleModal] = useState(false);
  const [loading, setLoading] = useState(true);
  let query = useQuery();

  useEffect(() => {
    if (apiToken) {
      setLoading(false);
      Repo.getServices(apiToken)
        .then((response) => {
          setServicesList(response.data);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });
    }
  }, []);

  const deleteService = () => {
    Repo.deleteService(apiToken, serviceId)
      .then((response) => {
        if (response.status == 200) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>

      <h1>Lista servizi</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Tutti i servizi disponibili</p>
          </div>

      <div className="row mt-2 text-right">
        <div className="col-lg-12 clearfix">
          <button
            type="button"
            className="btn btn-outline-primary float-right p-2"
            onClick={() =>
              (window.location.href =
                window.location.pathname + "/nuovo_servizio")
            }
          >
            <svg className="icon icon-primary">
              <use href={`${iconSprite}#it-plus-circle`} />
            </svg>{" "}
            <span className="align-middle">Nuovo servizio</span>
          </button>
        </div>
      </div>


      {servicesList && servicesList.length > 0 ? (
  <div className="mt-3">
    {/* Intestazione */}
    <div className="d-flex fw-bold border-bottom pb-2">
      <div className="col"><strong>Codice</strong></div>
      <div className="col"><strong>Titolo</strong></div>
      <div className="col col-7"><strong>Descrizione</strong></div>
      <div className="col text-right"></div>
    </div>

    {/* Lista servizi */}
    {servicesList.map((x, index) => (
      <div key={index} className="d-flex align-items-center py-2 border-bottom">
        
        <div className="col">{x.code}</div>
        <div className="col">{x.name}</div>
        <div className="col col-7">{x.description}</div>

        {/* Pulsanti azione */}
        <div className="col text-right">
          <Link to={`/servizi/visualizza_servizio?id=${x.id}`}>
            <button className="btn btn-outline-primary p-1" title="Dettaglio">
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-search`} />
              </svg>
            </button>
          </Link>

          <button className="btn btn-outline-danger p-1 ml-1"
                  type="button"
                  onClick={() => {
                    toggleModal(!isOpen);
                    setServiceId(x.id);
                  }}>
            <svg className="icon icon-danger">
              <use href={`${iconSprite}#it-delete`} />
            </svg>
          </button>
        </div>
      </div>
    ))}
  </div>
) : (
  <div className="text-center py-3">
    <b>Non sono presenti servizi</b>
  </div>
)}


      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Elimina Servizio"
        body="Confermi di voler eliminare questo servizio? L'operazione sarà possibile solo se non sono presenti servizi associati"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => deleteService()}
      ></ModalComponent>
      {!loading && <Loader></Loader>}
    </>
  );
}

export default ListServices;
